<template>
  <q-form @submit="this.onSubmit" class="form">
    <div class="form__info">
      <div class="info-row">
        <span class="label">Конструктив:</span>
        <span class="value">{{ this.data?.body?.constructive_name }}</span>
      </div>
    </div>

    <div class="form__section">
      <div class="form__section-title">Параметры создания АВР</div>
      
      <div class="form__item">
        <CustomInput
          label="День месяца"
          :value="this.formData.avr_day"
          @change_input="(value) => onChange('avr_day', value)"
          type="number"
          :min="1"
          :max="28"
        />
      </div>

      <div class="form__item">
        <CustomInput
          label="Процент"
          :value="this.formData.avr_percent"
          @change_input="(value) => onChange('avr_percent', value)"
          type="number"
          :min="0"
          :max="100"
        />
      </div>
    </div>

    <CustomModalFooter :btn-loading="this.loading" />
  </q-form>
</template>

<script>
import CustomInput from "@/components/form/CustomInput";
import CustomModalFooter from "@/components/modal/modals/modal-footer";
import { useCustomSnackbar } from "@/_helpers/hooks/useCustomSnackbar";

export default {
  name: "EditAvrSetting",
  components: { CustomInput, CustomModalFooter },
  props: ["data"],
  data() {
    return {
      loading: false,
      formData: {
        avr_day: this.data?.body?.avr_day ?? null,
        avr_percent: this.data?.body?.avr_percent ?? null,
      },
    };
  },
  methods: {
    onChange(key, value) {
      if (value === "" || value === null || value === undefined) {
        this.formData[key] = null;
      } else {
        const numValue = parseInt(value);
        this.formData[key] = isNaN(numValue) ? null : numValue;
      }
    },
    async onSubmit() {
      // Проверка: хотя бы одно поле должно быть заполнено
      if (
        (this.formData.avr_day === null || this.formData.avr_day === undefined) &&
        (this.formData.avr_percent === null || this.formData.avr_percent === undefined)
      ) {
        this.showErrorSnackbar("Необходимо заполнить хотя бы одно поле: день месяца или процент");
        return;
      }
      this.loading = true;
      await this.data?.onSubmit(this.formData);
      this.loading = false;
    },
  },
  setup() {
    const { showErrorSnackbar } = useCustomSnackbar();
    return { showErrorSnackbar };
  },
};
</script>

<style scoped lang="scss">
.form {
  display: flex;
  flex-direction: column;
  width: 400px;
  gap: 15px;

  &__info {
    background: #f5f5f5;
    padding: 12px;
    border-radius: 4px;

    .info-row {
      display: flex;
      margin-bottom: 8px;

      &:last-child {
        margin-bottom: 0;
      }

      .label {
        font-weight: 600;
        margin-right: 8px;
      }

      .value {
        color: #555;
      }
    }
  }

  &__section {
    display: flex;
    flex-direction: column;
    gap: 15px;
  }

  &__section-title {
    font-weight: 600;
    font-size: 16px;
    margin-bottom: 5px;
  }

  &__item {
    width: 100%;
    display: flex;
    gap: 16px;
  }

  @media (max-width: 460px) {
    width: 100%;
  }
}
</style>
